// Pays de résidence éligibles au service Passpro-France : pays africains membres de
// l'Organisation Internationale de la Francophonie (OIF). Hors de cette liste, la demande
// de Pré-enregistrement est rejetée (règle stricte, également contrôlée côté serveur).
export const PAYS_ELIGIBLES = [
  "Bénin",
  "Burkina Faso",
  "Burundi",
  "Cameroun",
  "Comores",
  "Congo (République du)",
  "Côte d'Ivoire",
  "Djibouti",
  "Gabon",
  "Guinée",
  "Guinée équatoriale",
  "Madagascar",
  "Mali",
  "Niger",
  "République centrafricaine",
  "République démocratique du Congo",
  "Sénégal",
  "Seychelles",
  "Tchad",
  "Togo",
];

export const ELIGIBILITE_RESIDENCE_MSG =
  "Non éligibilité au service, demande de Pré-enregistrement est rejetée.";

export const sansAccents = (texte) =>
  String(texte || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "");

export const normalisePays = (texte) =>
  sansAccents(texte).toLowerCase().replace(/[^a-z\s]/g, " ").replace(/\s+/g, " ").trim();

const ALIAS_PAYS = {
  "rd congo": "republique democratique du congo",
  "rdc": "republique democratique du congo",
  "congo kinshasa": "republique democratique du congo",
  "congo brazzaville": "congo",
  "republique du congo": "congo",
  "centrafrique": "republique centrafricaine",
  "guinee conakry": "guinee",
  "union des comores": "comores",
  "ivory coast": "cote d ivoire",
  "ivoire": "cote d ivoire",
};

export const isPaysEligible = (pays) => {
  const norm = normalisePays(pays);
  if (!norm) return false;
  const alias = ALIAS_PAYS[norm];
  return PAYS_ELIGIBLES.some((p) => normalisePays(p) === (alias || norm));
};
